import { api } from '@services';

import Invite, { IInvite, IInviteApiModel } from '@models/Invite.model';

const getStudioInvites = async (id: string): Promise<IInvite[]> => {
  const { data: invites } = await api.get<IInviteApiModel[]>(
    `/studios/${id}/invites`,
  );

  const _invites = Invite.arrayFromApiModel(invites);
  return _invites.sort((a, b) => a.roleLevel - b.roleLevel);
};

export { getStudioInvites };
